export function EmptyState({ message }: Readonly<{ message?: string }>) {
  return <p className="text-xs text-muted-foreground italic py-8 text-center">{message ?? 'No data for this period'}</p>;
}
